$('.Randomize').each(function (i, e) {
  const $e = $(e);
  const children = $e.children().toArray();

  for (let i = children.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [children[i], children[j]] = [children[j], children[i]];
  }

  children.forEach((child) => $e.append(child));
});
